"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourcesTabV2 = exports.ResourcesTab = exports.InstallationTabV2 = exports.InstallationTab = void 0;

var _preact = require("preact");

var _Message = require("../../../ui-components/Message");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _StatelessPanel = _interopRequireDefault(require("../../../panel/StatelessPanel"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _InstallationPanel = _interopRequireWildcard(require("./InstallationPanel"));

var _constants = require("@insided/shared/constants");

var _AwsAthenaParameters = _interopRequireWildcard(require("@insided/deprecated-control/integrations/components/bi-tools-connector/AwsAthenaParameters"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ResourcesTab = function ResourcesTab(_ref) {
  var isInstalled = _ref.isInstalled;
  var resources = [{
    title: "Connect Tableau with ".concat(_constants.PLATFORM_BRAND_NAME, " Data Lake"),
    icon: 'tableau',
    link: 'https://communities.gainsight.com/bi-connector-to-cc-data-lake-silver-layer-beta-207/how-to-connect-tableau-with-customer-communities-data-lake-through-bi-connector-22842'
  }, {
    title: "Connect PowerBI with ".concat(_constants.PLATFORM_BRAND_NAME, " Data Lake"),
    icon: 'bi-tools-connector-l',
    link: 'https://communities.gainsight.com/bi-connector-to-cc-data-lake-silver-layer-beta-207/how-to-connect-power-bi-with-customer-communities-data-lake-through-bi-connector-22843'
  }, {
    title: "Connect Looker with ".concat(_constants.PLATFORM_BRAND_NAME, " Data Lake"),
    icon: 'looker',
    link: 'https://communities.gainsight.com/bi-connector-to-cc-data-lake-silver-layer-beta-207/how-to-connect-looker-with-customer-communities-data-lake-through-bi-connector-22844'
  }];
  return (0, _preact.h)("div", {
    className: "resources__tab_templates"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app to generate access keys which can be used to connect with BI tools.",
    fullWidth: true
  }), resources.map(function (resource) {
    return (0, _preact.h)(_StatelessPanel.default, {
      key: resource.title,
      title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderWithImages, {
        title: resource.title,
        imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
        imageToName: resource.icon,
        customClass: "resources-link",
        meta: (0, _preact.h)(_Button.default, {
          size: "medium",
          title: "Read more",
          className: "qa-resources-link",
          onClick: function onClick() {
            // @ts-expect-error
            window.open(resource.link, '_blank').focus();
          }
        })
      }),
      customClass: "integration__panel resources-panel"
    });
  }));
};

exports.ResourcesTab = ResourcesTab;

var checkIsAwsAthenaDataAvailable = function checkIsAwsAthenaDataAvailable(awsAthenaData) {
  return Object.values(awsAthenaData).some(function (data) {
    return !!data;
  });
};

var InstallationTab = function InstallationTab(props) {
  var isInstalled = props.isInstalled,
      isLoading = props.isLoading,
      onGenerateAccessKeys = props.onGenerateAccessKeys,
      credentials = props.credentials,
      onClickCopy = props.onClickCopy,
      onClickUninstall = props.onClickUninstall,
      awsAthenaData = props.awsAthenaData;
  var isAthenaDataAvailable = checkIsAwsAthenaDataAvailable(awsAthenaData);
  var IntegrationPanel = {
    body: (0, _preact.h)(_InstallationPanel.default, {
      isInstalled: isInstalled,
      isLoading: isLoading,
      onGenerateAccessKeys: onGenerateAccessKeys,
      onClickCopy: onClickCopy,
      onClickUninstall: onClickUninstall,
      credentials: credentials,
      isAthenaDataAvailable: isAthenaDataAvailable
    }),
    customClass: 'panel__body_without_header'
  };
  var AwsAthenaParametersPanel = {
    body: (0, _preact.h)(_AwsAthenaParameters.default, {
      credentials: credentials,
      awsAthenaData: awsAthenaData
    }),
    customClass: 'panel__body_without_header'
  };
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [IntegrationPanel]
  })), (credentials === null || credentials === void 0 ? void 0 : credentials.id) && isInstalled && isAthenaDataAvailable && (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [AwsAthenaParametersPanel]
  })));
};

exports.InstallationTab = InstallationTab;

var ResourcesTabV2 = function ResourcesTabV2(_ref2) {
  var resources = _ref2.resources;
  return (0, _preact.h)("div", {
    className: "resources__tab_templates"
  }, resources.map(function (_ref3, index) {
    var title = _ref3.title,
        icon = _ref3.icon,
        link = _ref3.link;
    return (0, _preact.h)(_StatelessPanel.default, {
      key: index,
      title: (0, _preact.h)(_IntegrationPanelItems.IntegrationPanelHeaderWithImages, {
        title: title,
        imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
        imageToName: icon,
        customClass: "resources-link",
        meta: (0, _preact.h)(_Button.default, {
          size: "medium",
          title: "Read more",
          className: "qa-resources-link",
          onClick: function onClick() {
            // @ts-expect-error
            window.open(link, '_blank').focus();
          }
        })
      }),
      customClass: "integration__panel resources-panel"
    });
  }));
};

exports.ResourcesTabV2 = ResourcesTabV2;

var InstallationTabV2 = function InstallationTabV2(props) {
  var appName = props.appName,
      isInstalled = props.isInstalled,
      isLoading = props.isLoading,
      onGenerateAccessKeys = props.onGenerateAccessKeys,
      credentials = props.credentials,
      onClickCopy = props.onClickCopy,
      onClickUninstall = props.onClickUninstall,
      awsAthenaData = props.awsAthenaData,
      showAWSConnectionParams = props.showAWSConnectionParams,
      setShowAWSConnectionParams = props.setShowAWSConnectionParams,
      isInstallButtonDisabled = props.isInstallButtonDisabled;
  var isAthenaDataAvailable = checkIsAwsAthenaDataAvailable(awsAthenaData);
  var IntegrationPanel = {
    body: (0, _preact.h)(_InstallationPanel.InstallationPanelBodyV2, {
      appName: appName,
      isInstalled: isInstalled,
      isLoading: isLoading,
      onGenerateAccessKeys: onGenerateAccessKeys,
      onClickCopy: onClickCopy,
      onClickUninstall: onClickUninstall,
      credentials: credentials,
      isAthenaDataAvailable: isAthenaDataAvailable,
      isInstallButtonDisabled: isInstallButtonDisabled
    }),
    customClass: 'panel__body_without_header'
  };
  var AwsAthenaParametersPanel = {
    body: (0, _preact.h)(_AwsAthenaParameters.AWSAthenaParametersV2, {
      appName: appName,
      credentials: credentials,
      awsAthenaData: awsAthenaData,
      showAWSConnectionParams: showAWSConnectionParams,
      setShowAWSConnectionParams: setShowAWSConnectionParams
    }),
    customClass: 'panel__body_without_header'
  };
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (!isInstalled || isInstalled && (credentials === null || credentials === void 0 ? void 0 : credentials.secret)) && (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [IntegrationPanel]
  })), (credentials === null || credentials === void 0 ? void 0 : credentials.id) && isInstalled && isAthenaDataAvailable && (0, _preact.h)("div", {
    className: "installation__tab installation__connect_with_zapier_tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [AwsAthenaParametersPanel]
  })));
};

exports.InstallationTabV2 = InstallationTabV2;